module.exports = __webpack_public_path__ + "assets/jiudian.707d798f.svg";